import { Pagination } from "@mui/material";
import { useEffect } from "react";
// import { transactions } from "../../Utils/data";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { NavLink } from "react-router-dom";
import { checkTagValidity } from "../../Utils/Utils";
import { RENDEZ_VOUS_PAR_STATUS } from "../../Utils/constant";
import { useStoreApp } from "../../store/storeApp";
import { ContentLoading } from "../Widget/ContentLoading";
import { Pbo } from "../Widget/Pbo";
import { Periode } from "../Widget/Periode";

export const AbonnementRendezVous = ({ status, step, perm }) => {
  const abonnements = useStoreApp();
  useEffect(() => {
    abonnements.getListAbonnement(
      RENDEZ_VOUS_PAR_STATUS,
      { page: 0, param: "", size: 10 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=${status}`
    );
  }, [status]);

  const more = (page) => {
    abonnements.getListAbonnement(
      RENDEZ_VOUS_PAR_STATUS,
      { page: page - 1, param: "", size: 10 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=${status}`
    );
  };

  return (
    <>
      <div className="mt-3 lg:flex items-center gap-1">
        <input
          onChange={(e) =>
            abonnements.getListAbonnement(
              RENDEZ_VOUS_PAR_STATUS,
              { page: 0, param: e.target.value, size: 10 },
              `&periode=&mois=&annee=&dateDebut=&dateFin=&status=${status}`
            )
          }
          type="text"
          placeholder="Rechercher element..."
          className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
        />
        {/* <select
          onChange={(e) => enAttente(e.target.value)}
          className="select pl-non my-3"
        >
          <option disabled selected>
            Delais de traitement
          </option>
          <option value="">Tout afficher</option>
          <option value={"true"}>Intention dans le delais</option>
          <option value={"false"}>Intention hors delais</option>
        </select> */}
      </div>

      <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
        {abonnements?.listAbonnement?.data?.length === 0 ? (
          <div className="">
            <p className="text-sm ">
              Aucune donnée {status.toLowerCase().replace(/_/g, " ")}
            </p>
          </div>
        ) : abonnements?.listAbonnement?.data?.length !== 0 &&
          !abonnements?.loading ? (
          abonnements?.listAbonnement?.data?.map((item) => (
            <div className="relative bg-white rounded-xl border-slate-200 border shadow-md">
              <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                <p className="text-[12px] font-semibold">
                  N° {item?.abonnement?.eligibilite?.numeroTicket}
                </p>
                <div className="ml-auto flex items-center gap-2">
                  <div
                    className={` px-1 border  rounded-full py-[2px] text-xs ${
                      item?.abonnement?.statusConfirmation === "CONFIRMER"
                        ? "text-green-600"
                        : "text-gray-500"
                    }  font-semibold`}
                  >
                    {item?.abonnement?.statusConfirmation?.toLowerCase()}
                  </div>
                </div>
              </div>
              <div className=" px-3 py-2 ">
                <div className="items-center gap-2 space-y-3">
                  <Periode item={item} />
                  <Pbo
                    pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                    port={item?.brin}
                  />
                  <div className="flex gap-1 my-3">
                    <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                    <div>
                      <p className="text-[13px] font-medium">
                        {item?.abonnement?.client?.nomPrenoms}
                      </p>
                      <p className="text-xs flex font-semibold gap-2">
                        <span>{item?.abonnement?.client?.numero}</span> {" | "}{" "}
                        <span>{item?.abonnement?.client?.secondNumero}</span>{" "}
                      </p>
                    </div>
                  </div>
                  <h1 className="text-xs flex gap-1 items-center my-2">
                    <AvatarIcon />
                    Equipe en charge : {item?.equipe?.designation}
                  </h1>
                  <h1 className="text-xs flex gap-1 items-center my-2">
                    Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                    {item?.abonnement?.forfait?.categorie
                      ?.replace("_", "")
                      .toLowerCase()}
                  </h1>

                  <div className=" gap-1 ">
                    <div>
                      <p className="text-[13px] font-medium">
                        Numero FTTH : {item?.abonnement?.numeroFtth}
                      </p>
                      <p className="text-xs flex font-semibold gap-2">
                        SN : <span>{item?.abonnement?.numeroSerie}</span>
                      </p>
                    </div>
                  </div>

                  {status === "EN_ATTENTE_DE_SURVEY" ||
                  status === "EN_ATTENTE_DE_RACCORDEMENT" ? (
                    <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                      <p className="text-xs flex gap-1 items-center font-medium">
                        <CalendarIcon />
                        {status === "EN_ATTENTE_DE_SURVEY"
                          ? item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "SURVEY"
                            )?.date +
                            " de " +
                            item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "SURVEY"
                            )?.crenau?.heureDebut +
                            " à " +
                            item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "SURVEY"
                            )?.crenau?.heureFin
                          : item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "RACCORDEMENT"
                            )?.date +
                            " de " +
                            item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "RACCORDEMENT"
                            )?.crenau?.heureDebut +
                            " à " +
                            item?.listRendezVous?.find(
                              (e) => e.typeRendezVous === "RACCORDEMENT"
                            )?.crenau?.heureFin}
                      </p>
                    </div>
                  ) : null}

                  <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                    <p className="text-xs flex gap-1 items-center font-medium">
                      <HomeIcon />
                      {item?.abonnement?.batiment?.designation}
                    </p>
                    <p className="text-xs flex gap-1 font-medium">
                      <ArchiveIcon />{" "}
                      {item?.abonnement?.equipement?.designation}{" "}
                    </p>
                  </div>
                </div>
                <h1 className="my-2 text-[13px] font-medium flex items-center">
                  <SewingPinFilledIcon />
                  {item?.abonnement?.commune +
                    ", " +
                    item?.abonnement?.quartier}
                </h1>
                <div className="flex items-center gap-1">
                  <h5 className="text-xs font-medium ">Etape:</h5>
                  <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                    {item?.abonnement?.status?.toLowerCase().replace(/_/g, " ")}
                  </p>
                </div>
                {checkTagValidity(perm) ? (
                  <NavLink
                    className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                    to={`poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/${step}`}
                  >
                    Poursuivre
                  </NavLink>
                ) : null}
              </div>
            </div>
          ))
        ) : (
          <ContentLoading />
        )}
      </div>
      <div className="my-3 flex justify-end">
        <Pagination
          onChange={(event, newValue) => more(newValue)}
          onSelect={(selectedPage) => more(selectedPage)}
          count={abonnements?.listAbonnement?.totalPages}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </div>
    </>
  );
};
